export type MatchStatus = "upcoming" | "live" | "finished";

export function getMatchStatusLabel(status: MatchStatus) {
  if (status === "live") return "بدأت المباراة";
  if (status === "finished") return "انتهت المباراة";
  return "لم تبدأ بعد";
}

export function getDisplayMatchStatus(match: { status: MatchStatus; matchDate: Date | string }, now = new Date()): MatchStatus {
  if (match.status === "finished") return "finished";
  const kickoff = new Date(match.matchDate).getTime();
  const current = now.getTime();
  if (!Number.isFinite(kickoff)) return match.status;
  if (current < kickoff) return "upcoming";
  return current < kickoff + 120 * 60 * 1000 ? "live" : "finished";
}

export function getMatchScoreLabel(match: { status: MatchStatus; homeScore?: number | null; awayScore?: number | null; matchDate?: Date | string; providerFixtureId?: number | null }) {
  if (match.status === "upcoming") return null;
  if (match.homeScore == null || match.awayScore == null) {
    if (match.providerFixtureId == null) return "لا توجد نتيجة من المصدر";
    return match.status === "finished" ? "النتيجة غير متاحة من المصدر" : "النتيجة قيد التحديث";
  }
  return `${match.homeScore} - ${match.awayScore}`;
}
